import React, { useEffect,useState } from "react";
import classNames from 'classnames';
import { SearchBar } from "../search/searchBar.js";

function Form( {
	api
} ) {
	const [data, setData] = useState([]);
    const [error, setError] = useState([]);
	useEffect( () => {
		fetch( api).then( r => {
		return r.json();
		}).then(response => {
			setData( response );
			
			return response;
		}).catch( fault => {
			console.error( fault );
			setError( fault );
		}).finally(() => {
			// setLoading( false );
		});
	},[])
	return (
		<>
		<div className = "searchForm">	
			<SearchBar api = { api }/>		
		</div>
		</>
	);
}

export default Form;